
import { Component, Prop, Vue } from 'vue-property-decorator';
import { BackupScheduleDto } from '@/services/Backup/interfaces/index';

@Component
export default class DeleteBackupScheduleDialog extends Vue {
  @Prop()
  public readonly backupSchedule!: BackupScheduleDto;

  public visible: boolean = true;

  get message(): string {
    return `Are you sure you want to remove Backup Schedule: #${this.backupSchedule.id}?`;
  }

  public async deleteBackupSchedule(): Promise<void> {
    this.$emit('delete', this.backupSchedule);
    this.destroyComponent();
  }

  public destroyComponent(): void {
    this.$emit('close');
  }
}
